import http from '@/utils/http';

export function _fetchThemes (appId) {
    return http.get(`/api/s/_SID_/theme?appId=${appId}`).then((res) => res.data);
}

export function _createTheme (theme) {
    return http.post('/api/s/_SID_/theme', theme).then((res) => res.data);
}
